'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'rainbow';
var width = 640;
var height = 512;
var aliases = [127752];
var unicode = 'f75b';
var svgPathData = ['M8 448c4.4 0 8-3.6 8-8l0-88C16 184.1 152.1 48 320 48S624 184.1 624 352l0 88c0 4.4 3.6 8 8 8l-112 0c4.4 0 8-3.6 8-8l0-88c0-114.9-93.1-208-208-208S112 237.1 112 352l0 88c0 4.4 3.6 8 8 8L8 448zm112 0c4.4 0 8-3.6 8-8l0-88c0-106 86-192 192-192s192 86 192 192l0 88c0 4.4 3.6 8 8 8l-112 0c4.4 0 8-3.6 8-8l0-88c0-53-43-96-96-96s-96 43-96 96l0 88c0 4.4 3.6 8 8 8l-112 0z', 'M320 48C152.1 48 16 184.1 16 352l0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88C0 175.3 143.3 32 320 32S640 175.3 640 352l0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88C624 184.1 487.9 48 320 48zm0 112c-106 0-192 86-192 192l0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88c0-114.9 93.1-208 208-208s208 93.1 208 208l0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88c0-106-86-192-192-192zM240 352l0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88c0-53 43-96 96-96s96 43 96 96l0 88c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-88c0-44.2-35.8-80-80-80s-80 35.8-80 80z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;